export const CANDIDATE_PROFILE_MAX_EXPERIENCE = 25;
export const CANDIDATE_PROFILE_MAX_EDUCATION = 10;
export const CANDIDATE_PROFILE_MAX_PROJECTS = 20;
export const CANDIDATE_PROFILE_DESCRIPTION_MAX_LENGTH = 3000;
export const CANDIDATE_PROFILE_DATE_MAX_LENGTH = 40;
export const CANDIDATE_PROFILE_URL_MAX_LENGTH = 2000;
export const CANDIDATE_PROFILE_MAX_LINKS = 20;
export const CANDIDATE_PROFILE_TAG_MAX_LENGTH = 120;
